<div class="subBlockContainer" id="enroll-program" style="flex-shrink: 0; width: 984px;">
  <loading-screen *ngIf="!loadContent" [isChildLoader]="true" [showBlurTable]="false"></loading-screen>
  <div class="subBlockContent">
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <div class="chid-body">

      <!-- list -->
      <div style="padding: 20px;">
            <!-- filter -->
            <!-- <div class="inner-subBlock-wrapper row" style="margin: 20px 20px 0px 20px;">
              <div class="filter-wrapper">
                  <div class="col-md-3">
                      <div class="searchInputGroup toplevelsub">
                          <div class="searchIcon">
                              <img src="../images/new_ui/filter.png">
                          </div>
                          <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''" onblur="this.placeholder='Filter'" [(ngModel)]="searchField">
                      </div>
                  </div>
              </div>
          </div> -->
          <div>
              <!-- <div class="noData-wrapper" *ngIf="!customerPrograms.length">
                  <div>
                      <img src="../images/new_ui/no-subscription.png">
                  </div>
                  <label class="noData-label">
                      We couldn't find any <br />
                      customers
                  </label>
              </div> -->

              
              <ng-container>
                  <table  mat-table matSort [dataSource]="dataSource">
                      <ng-container matColumnDef="programName">
                          <td mat-cell *matCellDef="let program" style="width: 66%;">{{ program?.programName }}</td>
                      </ng-container>
                      <ng-container matColumnDef="button1">
                          <td mat-cell *matCellDef="let program" class="center-button">
                              <button class="button button-red button-round" (click)="associateExistingEndUser()">&nbsp;{{ program?.button1 }}&nbsp;</button>
                          </td>
                      </ng-container>
                      <ng-container matColumnDef="button2">
                        <td mat-cell *matCellDef="let program" class="center-button">
                            <button class="button button-red button-round" (click)="addNewTenant()">&nbsp;{{ program?.button2 }}&nbsp;</button>
                        </td>
                    </ng-container>

                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>
              </ng-container>
          </div>
      </div>

      
    </div>

  </div>
</div>
<router-outlet></router-outlet>
